
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/grid.zh.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-api-graph-grid-demo-api-graph-grid"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/grid.zh.md?type=demo')
};